import { NavObjectType } from "../../../Components/navigationTypes";
import { ListName } from "./ListFuncs";

export const searchBarPlaceholder: Record<ListName, string> = {
    "FormList": "OREA form",
}

export const thirdPartyNavigateObjs: Record<ListName, NavObjectType> = {
    "FormList": null,
}